module.exports = __webpack_public_path__ + "static/hero-34343f4f8fa7820d6eff5e3aa809f7de.jpg";